import { Observable } from "rxjs";
import { forkJoin } from "rxjs";
import { take } from "rxjs/operators";
import {
  BulkAction,
  ModalService,
  DataService,
} from "@bb-vendure/admin-ui/core";
import {
  DeleteShippingFeeDocument,
  DeleteShippingFeeMutation,
} from "src/generated-gql/graphql";

const deleteBulkAction: BulkAction = {
  location: "shipping-fee-table",
  label: "Delete Selected Shipping Fee",
  icon: "trash",
  iconClass: "is-danger",
  requiresPermission: (userPermissions) => {
    return userPermissions.includes("DeleteShippingFee");
  },
  onClick: ({ injector, selection, hostComponent, clearSelection }) => {
    const modalService = injector.get(ModalService);
    const dataService = injector.get(DataService);
    modalService
      .dialog({
        title: "Delete Selected Shipping Fee",
        body: `Are you sure you want to delete ${selection.length} shipping fees?`,
        buttons: [
          { type: "secondary", label: "Cancel" },
          { type: "primary", label: "Delete", returnValue: selection },
        ],
      })
      .pipe(take(1))
      .subscribe((result) => {
        if (result) {
          const deleteObservables: Observable<DeleteShippingFeeMutation>[] = [];
          for (const item in result) {
            deleteObservables.push(
              dataService.mutate(DeleteShippingFeeDocument, {
                id: result[item].id,
              })
            );
          }
          forkJoin(deleteObservables).subscribe(() => {
            hostComponent.refresh();
            clearSelection();
          });
        }
      });
  },
};

export { deleteBulkAction };
